module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "Badge5.af519543.png";